import { render, staticRenderFns } from "./bk.vue?vue&type=template&id=c03f4c5a"
import script from "./bk.vue?vue&type=script&lang=js"
export * from "./bk.vue?vue&type=script&lang=js"
import style0 from "./bk.vue?vue&type=style&index=0&id=c03f4c5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports